import React from 'react';
import PropTypes from 'prop-types';
import { getCategoryName, getSubCategoryName } from '../../../utils/functions';

const AssetModalHeader = ({
  toggleAsset,
  data,
}) => {
  const subCat = getSubCategoryName(data);
  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <div style={{ paddingBottom: 20, width: '100%', borderBottom: '1px solid #eee' }}>
        <h3 className="bold-text">{getCategoryName(data.category).toUpperCase()}</h3>
        {
          subCat && subCat !== getCategoryName(data.category) && (
            <h4 className="bold-text">{subCat}</h4>
          )
        }
        <button className="lnr lnr-cross modal__close-btn" type="button" onClick={toggleAsset} />
      </div>
    </div>
  );
};

AssetModalHeader.propTypes = {
  toggleAsset: PropTypes.func.isRequired,
  data: PropTypes.shape({}).isRequired,
};

export default AssetModalHeader;
